var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageIndex == 1)?_c('answerComponent',{attrs:{"user-info":_vm.weChatUserInfo,"client-data":_vm.clientData}}):_vm._e(),(_vm.pageIndex == 2)?_c('lotteryComponent',{attrs:{"user-info":_vm.weChatUserInfo,"client-data":_vm.clientData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }